import { useEffect, useState } from "react";

import { useApiClient } from "../../api-client";
import { Gender, restoreEmployee } from "./restoreEmployee";
import { useEmployment } from "./useEmployment";

interface Address {
  streetName?: string;
  streetNumber?: string;
  details?: string;
  street: string;
  postalCode: string;
  province: string;
  locality: string;
  district?: string;
}

type Employee = {
  id: string;
  name: string;
  surname: string;
  companyId: string;
  state: string;
  homeAddress: Address;
  email: string;
  birthDate?: string;
  sex: Gender;
  mobilePhone?: string;
};

const useEmployee = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [employee, setEmployee] = useState<Employee | null>(null);
  const { get } = useApiClient();
  const { employmentId } = useEmployment();

  const getEmployee = async () => {
    try {
      const { data } = await get(`/v1/employees/${employmentId}`);
      if (data) {
        const restoredEmployeeData = restoreEmployee(data.employee);
        setEmployee(restoredEmployeeData);
      }
    } catch (error) {
      throw new Error(error as unknown as string);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!employmentId) return;
    getEmployee();
  }, [employmentId]);

  return {
    employee,
    isLoading,
  };
};

export { type Employee, useEmployee };
